import { render } from "./Archivos-App.vue?vue&type=template&id=457ec4c6&scoped=true"
import script from "./Archivos-App.vue?vue&type=script&lang=js"
export * from "./Archivos-App.vue?vue&type=script&lang=js"

import "./Archivos-App.vue?vue&type=style&index=0&id=457ec4c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457ec4c6"]])

export default __exports__